import { reactive, toRefs, getCurrentInstance, computed } from 'vue';
export default {
  setup(props, content) {
    const {
      proxy
    } = getCurrentInstance();
    const keyWord = computed({
      get() {
        return proxy.$attrs.value;
      },
      set(newVal) {
        // const checked = proxy.$attrs.value.find((item) => {
        //   return item.label === newVal
        // })
        content.emit('changeValue', newVal);
      }
    });
    const state = reactive({});
    return {
      keyWord,
      ...toRefs(state)
    };
  }
};